<template>
  <div>
    <form @submit.prevent="onSubmit" v-if="!complete">
      <h2 class="fffheading font-primary font-extrabold tex-28 md:text-32 leading-1 -tracking-1/2 text-blue-brand mb-4">
        {{ selectedAdventure ? selectedAdventure.name : 'Enquire' }}
      </h2>
      <div class="flex flex-col md:flex-row">
        <div class="w-full md:w-1/2 md:mr-2.5 mb-5 md:mb-0">
          <label for="enquiryName" class="label block mb-2">Your Name *</label>
          <input
            type="text"
            name="enquiryName"
            class="input block w-full"
            placeholder="Full name..."
            v-model="name"
          />
          <error-message :errors="getErrors('name')"></error-message>
        </div>
        <div class="w-full md:w-1/2 md:ml-2.5" v-if="!selectedDeparture">
          <label for="enquiryGuests" class="label block mb-2">Expected Total Guests</label>
          <input
            type="number"
            name="enquiryGuests"
            class="input block w-20"
            :value="peopleCount"
            @input="onChangePeopleCount"
          />
          <error-message :errors="getErrors('people')"></error-message>
        </div>
      </div>

      <p class="my-6">
        We require at least one method to contact you back. If you provide both you can select which
        is your preferred.
      </p>

      <div class="flex my-8">
        <div class="w-2/3 md:w-1/2 mr-2.5">
          <label for="enquiryPhone" class="label block mb-2">Contact Number</label>
          <input
              type="tel"
              name="enquiryPhone"
              class="input block w-full"
              placeholder="Phone Number..."
              v-model="phone"
            />
          <!-- <phone-mask-input
            ref="phoneNumber"
            v-model="phone"
            autoDetectCountry
            inputClass="input block w-full"
            defaultCountry="UK"
            @onValidate="onUpdatePhoneNumber"
          ></phone-mask-input>
          <error-message :errors="getErrors('phone')"></error-message> -->
        </div>
        <div class="ml-2.5">
          <div v-if="hasEmailAndPhone">
            <span class="font-extrabold block mb-2">Preferred</span>
            <div class="relative inline-block mt-2">
              <input
                type="radio"
                name="preferredContact"
                value="phone"
                v-model="preferredContact"
                class="h-5 w-5 rounded cursor-pointer align-middle"
              />
              <span class="radio-dot"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex my-4">
        <div class="w-2/3 md:w-1/2 mr-2.5">
          <label for="enquiryEmail" class="label block mb-2">Contact Email</label>
          <input
            type="email"
            name="enquiryEmail"
            class="input block w-full"
            placeholder="Email address..."
            v-model="email"
          />
        </div>
        <div class="ml-2.5 mt-9">
          <div v-if="hasEmailAndPhone" class="relative inline-block">
            <input
              type="radio"
              name="preferredContact"
              value="email"
              v-model="preferredContact"
              class="h-5 w-5 rounded cursor-pointer align-middle"
            />
            <span class="radio-dot"></span>
          </div>
        </div>
      </div>

      <error-message :errors="getErrors('email')"></error-message>

      <div class="mt-8 mb-4">
        <label for="enquiryNotes" class="label block mb-2">Additional notes</label>
        <textarea
          name="enquiryNotes"
          class="input w-full"
          rows="4"
          placeholder="Give us an idea of what you are looking for eg. country, type &amp; grade of adventure, as well as any questions you have…"
          v-model="notes"
        ></textarea>
      </div>

      <error-message :errors="getErrors('notes')"></error-message>


      <!--
- 
- 
- 
- 
-  -->

      <div class="mt-8 mb-4">
        <div class="label block mb-2">What brought you to our website today?</div>
        <div class="grid grid-cols-2 gap-4">

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Search'), 'bg-white': !source.includes('Search')}" class="w-4 h-4 text-blue-600 border-gray-300 rounded flex-shrink-0 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Search" />
            <span class="text-gray-700">Search</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Social media'), 'bg-white': !source.includes('Social media')}" class="w-4 h-4 text-blue-600 border-gray-300 flex-shrink-0 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Social media" />
            <span class="text-gray-700">Social media</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('LinkedIn'), 'bg-white': !source.includes('LinkedIn')}" class="w-4 h-4 text-blue-600 border-gray-300 rounded flex-shrink-0 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="LinkedIn" />
            <span class="text-gray-700">LinkedIn</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('YellowWood Newsletter'), 'bg-white': !source.includes('YellowWood Newsletter')}" class="w-4 h-4 text-blue-600 flex-shrink-0 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="YellowWood Newsletter" />
            <span class="text-gray-700">YellowWood Newsletter</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Referral from another website'), 'bg-white': !source.includes('Referral from another website')}" class="w-4 h-4 flex-shrink-0 text-blue-600 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Referral from another website" />
            <span class="text-gray-700">Referral from another website</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Personal recommendation'), 'bg-white': !source.includes('Personal recommendation')}" class="w-4 h-4 text-blue-600 flex-shrink-0 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Personal recommendation" />
            <span class="text-gray-700">Personal recommendation</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Knew YWA already'), 'bg-white': !source.includes('Knew YWA already')}" class="w-4 h-4 text-blue-600 border-gray-300 flex-shrink-0 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Knew YWA already" />
            <span class="text-gray-700">Knew YWA already</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Other'), 'bg-white': !source.includes('Other')}" class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 flex-shrink-0 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Other" />
            <span class="text-gray-700">Other</span>
          </label>

        </div>
      </div>







      <div v-if="selectedDeparture">
        <departure-selection :force-show-dropdowns="true"></departure-selection>

        <h3 class="font-extrabold font-primary text-sm my-4">Price</h3>
        <div class="flex my-4">
          <div class="flex-auto w-1/2 text-center">
            <p class="font-extrabold text-sm font-primary">
              Deposit
              <button type="button" @click.prevent="showDepositTooltip = !showDepositTooltip">
                <svg-sprite
                  href="icon-tooltip"
                  class="h-4 w-4 ml-1 inline-block cursor-pointer"
                ></svg-sprite>
              </button>
              <generic-tooltip v-if="showDepositTooltip" @close="showDepositTooltip = false">
                <h3 class="font-extrabold text-2xl font-primary text-blue-brand">
                  Deposit
                </h3>
                <dynamic-copy
                  slug="deposit-description"
                  type="html"
                  class="my-4 text-lg text-blue-dark leading-relaxed"
                >
                  Loading...
                </dynamic-copy>
                <button type="button" class="button" @click.prevent="showDepositTooltip = false">
                  Close
                </button>
              </generic-tooltip>
            </p>
            <p class="text-3xl font-extrabold font-primary">
              <display-price
                :price-gbp="finalDepositAmountGBP"
                :price-usd="finalDepositAmountUSD"
              ></display-price>
            </p>
          </div>
          <div class="flex-auto w-1/2 text-center">
            <p class="font-extrabold text-sm font-primary">Total Payable</p>
            <p class="text-3xl font-extrabold font-primary">
              <display-price :price-gbp="priceGbp" :price-usd="priceUsd"></display-price>
            </p>
          </div>
        </div>
      </div>

      <div v-if="errorMessage" class="text-red-400 my-4">
        {{ errorMessage }}
      </div>

      <button type="submit" class="button sendenquiry min-w-280 md:min-w-360" :disabled="!canBeSubmitted || submitting">
        {{ submitting ? 'Sending...' : 'Send enquiry' }}
      </button>
    </form>
    <div v-else>
      <!-- @todo content here -->
      <h2 class="text-4xl font-extrabold">Thanks!</h2>
      <p>
        Thank you for your enquiry. We will be in touch very soon.
      </p>
    </div>
  </div>
</template>

<script>
import DepartureSelection from './DepartureSelection.vue';
import DisplayPrice from './DisplayPrice.vue';
import ErrorMessage from './ErrorMessage.vue';
import HandlesAdventures from './Mixins/HandlesAdventures';
import HandlesErrors from './Mixins/HandlesErrors';
import Route from '../src/Route';
import { mapGetters } from 'vuex';
import PhoneMaskInput from  "vue-phone-mask-input";
import SvgSprite from '../vendor/enso/components/SvgSprite.vue';
import GenericTooltip from './GenericTooltip.vue';
import DynamicCopy from './DynamicCopy.vue';

export default {
  components: {
    DepartureSelection,
    DisplayPrice,
    DynamicCopy,
    ErrorMessage,
    GenericTooltip,
    PhoneMaskInput,
    SvgSprite,
  },

  mixins: [HandlesErrors, HandlesAdventures],

  props: {
    allowNewsletterSignup: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      name: '',
      phone: '',
      email: '',
      preferredContact: 'phone',
      notes: '',
      source: [],
      newsletter: false,
      submitting: false,
      complete: false,
      showDepositTooltip: false,
    };
  },

  computed: {
    ...mapGetters('departure', ['priceGbp', 'priceUsd']),

    canBeSubmitted() {
      return !!this.name && (!!this.phone || !!this.email);
    },

    hasEmailAndPhone() {
      return !!this.email && !!this.phone;
    },

    finalDepositAmountGBP() {
      return this.selectedDeparture.deposit_amount_gbp * this.peopleCount;
    },

    finalDepositAmountUSD() {
      return this.selectedDeparture.deposit_amount_usd * this.peopleCount;
    },
  },
  mounted() {
    console.log('mounted!');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'showenquirymodal',
    });
  },
  methods: {
    onUpdatePhoneNumber(payload) {
      if (payload.isValidByLibPhoneNumberJs) {
        this.phone = payload.number;
      }
    },

    onSubmit() {
      this.submitting = true;
      this.resetErrors();

      const data = {
        name: this.name,
        phone: this.phone,
        email: this.email,
        people: this.peopleCount,
        newsletter: this.newsletter,
        notes: this.notes,
        source: this.source.join(', '),
        preferred_contact: this.preferredContact,
      };

      if (this.selectedDeparture) {
        Object.assign(data, this.compileAddonsAndExtrasForXHR());
      }

      if (this.selectedAdventure) {
        data.adventure = this.selectedAdventure.slug;
      }

      axios
        .post(Route('json.enquiry.store'), data)
        .then((response) => {
          if (response.status !== 200) {
            throw 'Network error.';
          }

          this.complete = true;
        })
        .catch(this.handleXHRErrors)
        .then(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
